// extracted by mini-css-extract-plugin
export var numpadContainer = "_n3-1";
export var phoneButton = "_n3-0";